import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { GetIcon } from '../../components/icons';
import { Text } from '../typography';
import type { IconName } from '../../components/icons/Icon.map';
import type { IconSize } from '../../components/icons/types';

export interface BadgeProps {
    text: string;
    leftIcon?: IconName;
    iconSize?: IconSize;
}

export const Badge: FC<BadgeProps> = ({ text, leftIcon, iconSize = 'sm' }) => (
    <Flex
        borderRadius="4px"
        backgroundColor="slt-primary-green.900"
        paddingX="8px"
        paddingY="2px"
        alignItems="center"
    >
        {leftIcon && <GetIcon name={leftIcon} size={iconSize} />}
        <Text style="bold" size="small" color="white" textTransform="uppercase">
            {text}
        </Text>
    </Flex>
);
